<template>
  <BaseFiltersSideBar
    v-model="model"
    @filters-submit="onFiltersSubmit"
  >
    <PurchaseInvoicesReportsFiltersForm
      v-model="filters"
      ref="purchase-invoices-reports-filters-form"
      @submit="onFiltersSubmit"
    />
  </BaseFiltersSideBar>
</template>

<script>
import BaseFiltersSideBar from '@/components/ui/sidebar/BaseFiltersSideBar.vue'
import PurchaseInvoicesReportsFiltersForm from "@/components/purchase-invoices-reports/form/PurchaseInvoicesReportsFiltersForm.vue"

export default {
  name: 'PurchaseInvoicesReportsListFilters',
  components: {
    BaseFiltersSideBar,
    PurchaseInvoicesReportsFiltersForm
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {},
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    clearFilters() {
      this.$refs['purchase-invoices-reports-filters-form'].clearForm()
    },
    onFiltersSubmit() {
      this.model = false
      this.$emit('filters-submit', this.filters)
    },
  },
}
</script>